import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

import { AppContext } from "./appContext";

const FormContext = createContext();

function FormContextProvider({ children }) {
  const [formData, setFormData] = useState({});

  const handleSubmit = (e, callback) => {
    e.preventDefault();
    console.log("formData: ", formData);
    typeof callback === "function" && callback(formData);
    console.log("submitted!", e);
  };

  const handleReset = () => {
    setFormData({});
    console.log("reset data");
  };

  const handleFormDataUpdate = (k, v) => {
    setFormData((prevData) => {
      const newData = { ...prevData };
      newData[k] = v;
      return newData;
    });
  };

  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData,
        handleSubmit,
        handleReset,
        handleFormDataUpdate,
      }}
    >
      {children}
    </FormContext.Provider>
  );
}

export { FormContextProvider, FormContext };
